import React from "react";
import { TextField } from "@mui/material";

import request from "../../../utilities/requests";

const menuItems = Array.from({ length: 30 }, (_, i) => i + 1);

const NumberOfTables = ({ pairingEvent }) => {
  const [tables, setTables] = React.useState(null);

  React.useEffect(() => {
    if (pairingEvent) {
      setTables(pairingEvent.numberOfTables);
    }
  }, [pairingEvent]);


  return (
    <TextField 
      size="small"
      label="Tables"
      value={tables || ''}
      style={{width: 100}}
      disabled={true}
    />

  )

};

export default NumberOfTables;
